import React from 'react';
import PropTypes from 'prop-types';

const sizes = {
  default: `py-3 px-8`,
  lg: `py-4 px-12`,
  xl: `py-5 px-16 text-lg`
};

const variants = {
  primary: `bg-primary hover:bg-primary-darker`,
  secondary: `bg-secondary hover:bg-secondary-darker`
};

const Button = ({ children, className, size, variant }) => {
  return (
    <button
      type="button"
      className={`
        ${sizes[size] || sizes.default}
        ${variants[variant] || variants.primary}
        ${className}
        rounded
        text-white
    `}
    >
      {children}
    </button>
  );
};

Button.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  size: PropTypes.oneOf(['default', 'lg', 'xl']),
  variant: PropTypes.oneOf(['primary', 'secondary'])
};

Button.defaultProps = {
  className: '',
  size: 'default',
  variant: 'primary'
};

export default Button;
